module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/voices/icon-voice-man-50_f695bdebe89850ba0944f2a7e9bdbf03.png";